import { Suspense } from 'react'
import Preloader from '@/components/Preloader'
import EduNavFooter from '@/components/eduNav/EduNavFooter'
import EduNavTopNavigationBar from '@/components/eduNav/EduNavTopNavigationBar'
import BackToTop from '@/components/BackToTop'
const EduNavLayout = ({ children }) => {
  return (
    <>
      <Suspense>
        <EduNavTopNavigationBar />
      </Suspense>
      <Suspense fallback={<Preloader />}>{children}</Suspense>
      <Suspense>
         <BackToTop />
        <EduNavFooter />

      </Suspense>
    </>
  )
}

export default EduNavLayout
